import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicationType } from 'src/api/models/application-type';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ApplicationService,CustomerService } from 'src/api/services';
import { CustomerApplication } from 'src/api/models';


@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.css']
})
export class MarketplaceComponent implements OnInit {

  public applications : ApplicationType[];
  
  constructor(
    private service: ApplicationService,
    private app: ApplicationConfigService,
    public azureAuthService: AzureAuthService,
    public customerService: CustomerService,
    private toasterService: ToastrService) { 
      app.customerChanged$.subscribe(cid => {
        this.ngOnInit();
      }); 
  }

  ngOnInit(): void {    
    if (this.azureAuthService.isGlobalViewer()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => { 
          this.app.customers = c;
        });
      }
    } 
    if (this.app.customerId == null) {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }
    // need to know what applications they have enabled
    // show onboarding screen if new
    // jump straight to live if already purchased
    this.service.ApplicationGetAll(this.app.customerId).subscribe(r => {
      this.applications = r;
    });
  }

  /*buyNow(application: ApplicationType){
    this.service.ApplicationPurchase({applicationUri: application.applicationUri, customerId: this.app.customerId}).subscribe(d =>{
        this.toasterService.success("Purchase Complete", "Application");
    });
  }*/
}
